import React from "react";
import "./Loader.css";

const Preloader = () => {
  return (
    <div id="Loader">
      <div className="Loader-content">
        <div className="Loader"></div>
      </div>
    </div>
  );
};

export default Preloader;
